module.exports = __webpack_public_path__ + "static/media/ls6.9039dddb.svg";